module.exports = __webpack_public_path__ + "static/media/document_in_review.46a323b3.svg";